<template>
    <All @updated="getNewData" ref="orders" model="stock/Orders" :data.sync="allOrders"  :immediate="true" v-slot="{ data }">
        <div class="text-xs">

            <div v-if="Object.keys(allOrders).length !== 0">
                <div class="bg-box rounded mx-3 mb-4 flex tracking-wider" v-for="order in allOrders.data.orders" :key="order.id">
                    <div class="w-2/5 flex py-2">    
                        <div class="w-2 h-full bg-aux mx-2 rounded"></div>      
                        <div class="flex flex-col justify-around w-full">   

                            <div class="flex items-center justify-between text-font-gray font-bold mx-1">

                                <span>{{order.date | moment('MM-DD | HH:mm')}}</span>
                                <span>#{{order.id}}</span>
                            </div>

                            <div class="my-2 mx-2 font-bold">
                                <div class="text-white text-xl">{{order.customer_name}}</div>
                                <div class="text-font-gray text-lg">{{order.city}}</div>
                            </div> 
                            <p v-if="order.pay_method" class="text-white mx-2">{{order.pay_method}}</p>
                            <div class="mx-2 my-1">
                                <span v-if="!order.source && order.store === 'Web'" class="text-aux">No hay fuente disponible</span>
                                <span v-if="order.store !== 'Web'" class="text-aux">Tienda {{order.store}}</span>
                                <span v-if="order.medium" class="text-aux">{{order.medium}} > </span>
                                <span class="text-aux">{{order.source}}</span>
                            </div>

                        </div>

                    </div>

                    <div class="w-px bg-gray-900 ml-1"></div>

                    <div class="w-3/5 flex smallText p-4">

                        <div class="font-bold my-2">
                            <div class="text-white text-xl">{{order.total | numberFormat(2)}}€</div>

                            <div class="text-font-gray mr-3">
                                <div class="flex">
                                    <BoxIcon class="pt-1 text-aux"/>
                                    <div class="my-1 ml-1">Uds: <span class="text-aux ml-1">{{order.quantity}}</span></div>
                                </div>

                                <div class="flex">
                                    <ShopIcon class="text-aux"/>
                                    <div class="flex ml-1">Compras: <span class="text-aux ml-1">{{order.customer_sales}}</span></div> 
                                </div>

                                <div class="ml-3">{{order.customer_amount}}€</div>  
                            </div>

                        </div>

                        <div class="flex overflow-x-auto">

                            <template v-for="(product, idx) in order.products">
                                <img :key="idx" v-if="product.image" class="rounded-lg mx-2 w-1/3" :src="product.image">
                            </template>
                        </div>

                    </div>               
                </div>
            </div>
        </div>
    </All>

</template>

<script>

    import ShopIcon from '@/components/icons/ShopIcon.vue'
    import BoxIcon from '@/components/icons/BoxIcon.vue'
    import All from '@/api/components/All.vue'

    export default {
        name: 'ordersCard',

        components: {
            All,
            BoxIcon,
            ShopIcon
        },
        data(){
            return {
                timeOut: null,
                allOrders: {}
            }
        },

        methods: {  
            getNewData(){
                clearTimeout(this.timeOut)
                this.timeOut = setTimeout( () => {
                    this.$refs.orders.request()
                }, 60 *1000)
            } 
        }
    }
</script>